import React from 'react'
let vector = ['1'];
let validate_count = 1;

const Video = function video ({banners}){
    return (
        <section>
            {vector.map((v) => {
                if (banners.length > 0 && validate_count == 1) {
                    validate_count = 2;
                    setTimeout(function (){
                        $('#sliderHomeMob').slick({
                            arrows: false,
                            dots: true,
                            autoplay: true,
                            autoplaySpeed: 10000,
                        });
                        $('#sliderHome').slick({
                            arrows: false,
                            dots: true,
                            autoplay: true,
                            autoplaySpeed: 10000,
                        });
                    },100);
                    
                    setTimeout(function (){
                    $('#source_1').get(0).play()
                    $('#source_2').get(0).play()
                    //videoElement = document.getElementById('source_2');
                    //videoElement.play();
                    },5000);
                }
            })}
            <section className="sliderHomeMob">
                <div className="container w90" id="sliderHomeMob">
                    {banners.map((b)=>
                        {
                        if($(document).width() < 600 ){
                            if(b.img_mobile !== null){
                                if(b.product_id !== null){
                                    return (
                                        <a className="flex" key={b.id} href={https+'product/'+b.product_id}>
                                            <img src={https+b.img_mobile} alt="bannerHome"/>
                                        </a>
                                    )
                                }else{
                                    return (
                                        <a className="flex" key={b.id}>
                                            <img src={https+b.img_mobile} alt="bannerHome"/>
                                        </a>
                                    )
                                }
                            }
                            if(b.video !== null){
                                return (
                                    <a className="flex" key={b.id}>
                                        <div class="video-container">
                                            <video id={"source_"+b.id} playsInline="playsinline" autoPlay="autoplay" muted="muted" loop controls>
                                                <source src={https+b.video} type="video/mp4" />
                                            </video>
                                            <div class="caption">
                                                <h2>Your caption here</h2>
                                            </div>
                                        </div>
                                    </a>
                                )
                            }
                        }
                        }
                    )}
                </div>
            </section>
            <section className="sliderHome dnone relative">
                <div className="container w90" id="sliderHome">
                    {banners.map((b)=>
                        {
                        if($(document).width() > 600 ){
                            if(b.img !== null){
                                if(b.product_id !== null){
                                    return (
                                        <a className="item" key={b.id} href={https+'product/'+b.product_id}>
                                            <img src={https+b.img} alt="bannerHome"/>
                                        </a>
                                    )
                                }else{
                                    return (
                                        <a className="item" key={b.id}>
                                            <img src={https+b.img} alt="bannerHome"/>
                                        </a>
                                    )
                                }
                            }
                            if(b.video !== null){
                                return (
                                    <a className="flex" key={b.id}>
                                        <div class="video-container">
                                            <video id={"source_"+b.id} autoPlay="" muted="muted" playsInline="" data-wf-ignore="true" data-object-fit="cover" loop controls >
                                                <source src={https+b.video} type="video/mp4" />
                                            </video>
                                            <div class="caption">
                                                <h2>Your caption here</h2>
                                            </div>
                                        </div>
                                    </a>
                                )
                            }
                        }
                        }
                    )}
                </div>
            </section>
        </section>
    )
}

export default Video
